import React from "react";
import OrdersTable from "../../orders/OrdersTable";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Orders = () => {
  const navigate = useNavigate();

  const handleView = () => {
    navigate("/supervisor/orders/all", { state: { isFromDashboard: true } });
  };

  return (
    <>
      <OrdersTable type="All" title="First 10 New Orders" />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#7152F3", // Purple color from the image
            color: "white",
            padding: "8px 16px",
            marginTop: "16px",
            borderRadius: "4px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#5a32a3", // Slightly darker purple on hover
            },
          }}
          onClick={handleView}
        >
          View All Orders
        </Button>
      </Box>
    </>
  );
};

export default Orders;
